import {
  IInitialStateFamilyGroup,
  iInitialStateFamilyGroup,
} from "../../../Interfaces/IFamilyGroup";
import {
  ERROR_MESSAGES,
  FIELDS,
} from "../../../Interfaces/IFamilyGroupFormField";
import store from "../../../Store/store";
import { Card } from "@sainsburys-tech/luna-card";
import { Container } from "@sainsburys-tech/luna-grid";
import { FC, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { editTableFamilyGroupPayload } from "../../../Redux/Actions/editTableFamilyGroupActions";
import FamilyGroupForm from "./familyGroupForm";
import { validateField, validateForm } from "./familyGroupValidations";
import { editTablePayload } from "../../../Redux/Actions/editTableActions";
import { IsNullEmptyUndefined } from "../../Product/Product-Edit/productValidations";

export interface FamilyGroupFormProps {
  closeModal: () => void;
}

const FamilyGroupEditFormEdit: FC<FamilyGroupFormProps> = ({ closeModal }) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const [state, setState] = useState<IInitialStateFamilyGroup>(
    payload.data?.editPayload
      ? payload.data.editPayload
      : iInitialStateFamilyGroup
  );

  useEffect(() => {
    if (payload.data) {
      setState(payload.data.editPayload);
    } else {
      setState(iInitialStateFamilyGroup);
    }
  }, [payload]);

  /*Rules and validation mechanism go here*/
  /*Validations*/
  const required = (value: any, formValues: any, field: any) => ({
    valid: !!value,
    code: "required",
  });
  const inputType = (value: any, formValues: any, field: any) => {
    if (checkInputType(field, value)) {
      return { valid: true, code: "inputType" };
    } else {
      return { valid: false, code: "inputType" };
    }
  };
  /*Validations*/
  /*Rules*/
  const rules = {
    required,
    inputType,
  };
  /*Rules*/

  /*Rules and validation mechanism go here*/

  /*Events of form*/
  const handleBlur = (target: any) => {
    const { values, errors } = state;
    const fieldName = target.name || target.id;
    const valid = validateField(
      fieldName,
      values[fieldName as keyof typeof values],
      values
    );
    setState((initialState: IInitialStateFamilyGroup) => {
      return {
        ...initialState,
        errors: { ...errors, ...valid.errors },
        dirty: true,
      };
    });
  };

  const handleChange = (target: any, familygroup: string, desc: string) => {
    let data = { key: "", value: "" };
    if (target === undefined) {
      data = {
        key: "FamilyGroupNew",
        value: familygroup,
      };
    } else {
      data = {
        key: target.name,
        value: target.value,
      };
    }
    setState((initialState: IInitialStateFamilyGroup) => {
      return {
        ...initialState,
        values: { ...values, [data.key]: data.value },
        dirty: true,
      };
    });
    //On change of Product we're making family group null to force user to search again
    if (target !== undefined && target.name === FIELDS.ProductType.name) {
      setState((initialState: IInitialStateFamilyGroup) => {
        let data = {
          ...initialState,
          values: {
            ...initialState.values,
            ["FamilyGroupNew"]: "",
            ["FamilyGroup"]: "",
            ["familyGroup"]: "",
          },
          dirty: true,
        };
        return data;
      });
    }
  };

  const checkInputType = (field: string, value: string) => {
    switch (field) {
      case "weightCap":
        return RegExp("[+-]?([0-9]*[.])?[0-9]+").test(value);
      default:
        return true;
    }
  };

  const handleSubmit = (e: any) => {
    const { values } = state;
    e.preventDefault();
    const valid = validateForm(values);
    if (valid.errors) {
      setTimeout(scrollToError, 100);
    }
    setState((initialState: IInitialStateFamilyGroup) => {
      return {
        ...initialState,
        errors: { ...errors, ...valid.errors },
        submitted: valid.result,
      };
    });

    let familyGroup = IsNullEmptyUndefined(values.FamilyGroup)
      ? payload.data?.editPayload?.values?.FamilyGroup
      : values.FamilyGroup;
    let familyGroupNew = values.FamilyGroupNew;
    const editPayload = {
      Id: payload.data.id,
      FamilyGroup: familyGroup, //values.FamilyGroup,
      BusinessUnit: values.BusinessUnit,
      SuperCategory: values.SuperCategory,
      Category: values.Category,
      SubCategory: values.SubCategory,
      Segment: values.Segment,
      ProductCount: values.ProductCount,
      Company: values.Company,
      FamilyGroupNew: familyGroupNew, //values.FamilyGroupNew,
      SuperCatDesc: values.SuperCatDesc,
      SubCategoryDesc: values.SubCategoryDesc,
      CategoryDesc: values.CategoryDesc,
      BusinessUnitDesc: values.BusinessUnitDesc,
      SegmentDesc: values.SegmentDesc,
      ProductType: values.ProductType,
    };
    store.dispatch(editTablePayload(editPayload));
    closeModal();
  };
  const clearAll = (e: any) => {
    setState(iInitialStateFamilyGroup);
  };
  const scrollToError = () => {
    const firstError = document.querySelector(
      ".ln-c-form-group.has-error"
    ) as HTMLElement | null;
    if (firstError) {
      window.scrollTo(0, firstError.offsetTop);
      const inputField = firstError.querySelector(
        "input"
      ) as HTMLElement | null;
      inputField?.focus();
    }
  };
  /*Events of form*/

  const { values, errors, submitted, dirty } = state;

  return (
    <>
      <h4 className="familyGroupModal-heading">Edit Family Group</h4>
        <FamilyGroupForm
          values={values}
          onBlur={(event) => handleBlur(event.target)}
          onChange={(event, familygroup: string, desc: string) =>
            handleChange(event.target, event.label, event.value?.desc)
          }
          onSubmit={(event) => handleSubmit(event)}
          onClearAll={(event) => clearAll(event)}
          onCancel={closeModal}
          errors={errors}
          dirty={dirty}
          submitted={submitted}
        />
    </>
  );
};

export default FamilyGroupEditFormEdit;
